import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ExternalNodeModules = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h5" gutterBottom>🔗 External Node Modules</Typography>
            <Typography variant="body1" gutterBottom>
                External modules can be imported from the collection path if they are installed inside the collection folder
                and contain a <code>package.json</code> file. For Example: import faker package to generate random request body
            </Typography>
            <img
                src="/scripts/ScriptOverview.png"
                alt="Validations in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '70%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />
        </Box>
    )
};

export default ExternalNodeModules;
